<div [formGroup]="form" fxLayout="column">
  <div fxLayout="row" fxLayoutGap="10px">
    <mat-form-field>
      <mat-label>Prd Date Of Hire</mat-label>
      <input
        matInput
        formControlName="prdDateOfHire"
        [matDatepicker]="prdDateOfHirePicker"
        required
        [min]="minDate"
        [max]="maxDate"
      />
      <mat-datepicker-toggle matSuffix [for]="prdDateOfHirePicker"></mat-datepicker-toggle>
      <mat-datepicker #prdDateOfHirePicker></mat-datepicker>
      <mat-error *ngIf="form.controls.prdDateOfHire.hasError('matDatepickerMin')"
        >Date is too far in the past.</mat-error
      >
      <mat-error *ngIf="form.controls.prdDateOfHire.hasError('matDatepickerMax')"
        >Date must be on or before today.</mat-error
      >
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="10px">
    <mat-form-field>
      <mat-label>Complete Date</mat-label>
      <input
        matInput
        formControlName="completeDate"
        [matDatepicker]="completeDatePicker"
        [min]="minDate"
        [max]="maxDate"
      />
      <mat-datepicker-toggle matSuffix [for]="completeDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #completeDatePicker></mat-datepicker>
      <mat-error *ngIf="form.controls.completeDate.hasError('matDatepickerMin')"
        >Date is too far in the past.</mat-error
      >
      <mat-error *ngIf="form.controls.completeDate.hasError('matDatepickerMax')"
        >Date must be on or before today.</mat-error
      >
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="10px">
    <mat-form-field>
      <mat-label>Final Records Date</mat-label>
      <input
        matInput
        formControlName="finalRecordsDate"
        [matDatepicker]="finalRecordsDatePicker"
        [min]="minDate"
        [max]="maxDate"
      />
      <mat-datepicker-toggle matSuffix [for]="finalRecordsDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #finalRecordsDatePicker></mat-datepicker>
      <mat-error *ngIf="form.controls.finalRecordsDate.hasError('matDatepickerMin')"
        >Date is too far in the past.</mat-error
      >
      <mat-error *ngIf="form.controls.finalRecordsDate.hasError('matDatepickerMax')"
        >Date must be on or before today.</mat-error
      >
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="10px">
    <mat-form-field>
      <mat-label>Separation Date</mat-label>
      <input
        matInput
        formControlName="separationDate"
        [matDatepicker]="separationDatePicker"
        [max]="maxDate"
      />
      <mat-datepicker-toggle matSuffix [for]="separationDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #separationDatePicker></mat-datepicker>
      <mat-error *ngIf="form.controls.separationDate.hasError('matDatepickerMax')"
        >Date must be on or before today.</mat-error
      >
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="10px">
    <mat-form-field fxFlex="100">
      <mat-label>Separation Type</mat-label>
      <mat-select formControlName="separationType">
        <mat-option
          *ngFor="let option of separationTypeOptions"
          [value]="option.code"
          (onSelectionChange)="onSeparationTypeChange($event)"
        >
          {{ option.description }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="10px" *ngIf="form?.controls.separationType.value === 'Other'">
    <mat-form-field fxFlex="100">
      <input
        matInput
        maxlength="4000"
        formControlName="separationTypeDetail"
        placeholder="Separation Type Detail"
        required
      />
      <mat-error>Separation Type Detail is Required</mat-error>
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="10px">
    <mat-form-field fxFlex="205px">
      <mat-label>Processing State</mat-label>
      <mat-select formControlName="processingState">
        <mat-option
          *ngFor="let option of processingStateOptions"
          [value]="option.value"
          [disabled]="!option.selectable"
        >
          {{ option.value | humanize }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="10px" class="checkbox-row">
    <mat-checkbox type="checkbox" formControlName="relevantDocuments">
      Relevant Documents</mat-checkbox
    >
  </div>
</div>
